import React from 'react'
import moment from 'moment'
import { Dropdown, Grid } from 'semantic-ui-react'
import { ChartHeader } from './ChartHeader'
import '../../../assets/styles/dashboard.less'
import { format } from '@cbgms/base/utils/datetime'

const years = [
  {
    key: moment().year(),
    text: moment().year(),
    value: moment().year()
  },
  {
    key: moment().subtract(1, 'years').format(format.year),
    text: moment().subtract(1, 'years').format(format.year),
    value: moment().subtract(1, 'years').format(format.year)
  },
  {
    key: moment().subtract(2, 'years').format(format.year),
    text: moment().subtract(2, 'years').format(format.year),
    value: moment().subtract(2, 'years').format(format.year)
  },
  {
    key: moment().subtract(3, 'years').format(format.year),
    text: moment().subtract(3, 'years').format(format.year),
    value: moment().subtract(3, 'years').format(format.year)
  },
  {
    key: moment().subtract(4, 'years').format(format.year),
    text: moment().subtract(4, 'years').format(format.year),
    value: moment().subtract(4, 'years').format(format.year)
  }
]

interface IYearSelectorProps {
  title: string
  placeholder: string
  onYearChange: (year: string) => void
  loading?: boolean
}

export const YearSelector: React.FC<IYearSelectorProps> = props => {
  return (
    <Grid>
      <Grid.Row columns='equal'>
        <Grid.Column>
          <ChartHeader title={props.title} loading={props.loading} />
        </Grid.Column>
        <Grid.Column textAlign='right'>
          <Dropdown
            placeholder={props.placeholder}
            selection
            compact
            options={years}
            onChange={(_event, data) => props.onYearChange(data.value as string)}
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  )
}
